var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 0H6V10H4V0Z","key":0}),React.createElement("path",{"d":"M10 4L10 6L-8.74228e-08 6L0 4L10 4Z","key":1})]);
}

IconPlus.defaultProps = {"viewBox":"0 0 10 10","fill":"currentColor"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
